import React from 'react';

function Breadcrumb({menuSet}) {
	return '';
}

export default Breadcrumb;